import React from 'react';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import { Box } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import PersonIcon from '@material-ui/icons/Person';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import DeleteIcon from '@material-ui/icons/Delete';

import { useDispatch } from 'react-redux';
import UsersRequests from 'services/users';

const useStyles = makeStyles(theme => ({
  demo: {
    backgroundColor: theme.palette.background.default,
  },
}));

const AddedUsers = ({ addedUser }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const handleRemoveAddedUser = () => {
    dispatch(UsersRequests.removeSingleAddedUser(addedUser.id));
  };

  return (
    <Box className={classes.demo}>
      <List>
        <ListItem>
          <ListItemAvatar>
            <Avatar>
              <PersonIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText primary={addedUser.name} secondary={addedUser.phone} />
          <ListItemSecondaryAction>
            <IconButton edge="end" aria-label="delete" onClick={handleRemoveAddedUser}>
              <DeleteIcon />
            </IconButton>
          </ListItemSecondaryAction>
        </ListItem>
      </List>
    </Box>
  );
};

export default AddedUsers;
